import { render, staticRenderFns } from "./SurveyUserResultsModal.vue?vue&type=template&id=0ffa44e1&scoped=true&"
import script from "./SurveyUserResultsModal.vue?vue&type=script&lang=js&"
export * from "./SurveyUserResultsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffa44e1",
  null
  
)

export default component.exports